import { render } from "./FibuExports.vue?vue&type=template&id=1465da3a&scoped=true"
import script from "./FibuExports.vue?vue&type=script&lang=js"
export * from "./FibuExports.vue?vue&type=script&lang=js"

import "./FibuExports.vue?vue&type=style&index=0&id=1465da3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1465da3a"]])

export default __exports__